class ApiFabric {
  constructor() {
    this.instances_list = {};
    this.valid_instances_list = {};
    this.error_handler = false;
  }
  setValidInstances(instances_list) {
    this.valid_instances_list = instances_list;
  }

  /**
   * Возвращает необходимый инстанс API
   * @param {string} api_instance_name имя класса API
   * @param {boolean} need_error_handling нужна ли привязка к стору в API для обработки ошибок
   * @return {*}
   */
  getInstance(api_instance_name, need_error_handling) {
    let instance;
    if (!this.valid_instances_list[api_instance_name]) {
      console.error("Unregistered API instance");
    }
    if (this.instances_list[api_instance_name]) {
      instance = this.instances_list[api_instance_name];
    } else {
      instance = new this.valid_instances_list[api_instance_name]();
    }
    if (need_error_handling) {
      if (!this.error_handler) {
        console.error("You need register store in ApiFabric class!");
      }
      instance.registerErrorHandler(this.error_handler);
    }
    return instance;
  }
  registerErrorHandler(handler) {
    this.error_handler = handler;
  }
}
export default ApiFabric;
